import { Derivative } from "@models/derivative/currencies/derivative";
import { BFFAsset } from "@core-services/bff-assets.service";
import { TRADABLES_TYPE } from "@helpers/constants";
import { AssetPrice } from "@models/tradable/split/asset_price";

const EXCHANGE_QUOTRIX_ID: string = "RVhDSEFOR0U6cmVhbF9zdG9ja3M=";

export class BFFSecurityAsset extends Derivative {
	public isRealSecurities(): boolean {
		return true;
	}
	protected _isin: string = "";
	public getIsin(): string {
		return this._isin;
	}
	protected _isStock: boolean = false;
	public isStock(): boolean {
		return this._isStock;
	}
	protected _isEtf: boolean = false;
	public isEtf(): boolean {
		return this._isEtf;
	}
	protected _isEtc: boolean = false;
	public isEtc(): boolean {
		return this._isEtc;
	}
	protected _exchange: string = "";
	public getExchange(): string {
		return this._exchange;
	}

	protected _price: number = +this.fragment.price.value;
	public setPrice(n: number): void {
		this._price = n;
	}

	public getAssetPrices(): AssetPrice {
		const assetPrice = new AssetPrice();
		assetPrice.setPrice(this._price);
		return assetPrice;
	}

	public getPrice(): number {
		return this._price;
	}

	public getPid(): string {
		return this.pid;
	}

	// TODO: will it have a real stock security asset type?
	public getCurrencyType(): string {
		return TRADABLES_TYPE.SECURITY_TOKEN;
	}

	public getAvgPrice(): number {
		return this.getPrice() ?? 0;
	}

	public getV4PathName(): string | null {
		if (this.isStock()) {
			return "/asset/equity-stock/";
		} else if (this.isEtf()) {
			return "/asset/equity-etf/";
		} else if (this.isEtc()) {
			return "/asset/equity-etc/";
		}
		return null;
	}

	public getTradableActions(): string[] {
		return [];
	}

	constructor(private fragment: BFFAsset) {
		super();
		this.setId(String(fragment.idInternal));
		this.pid = fragment.pid;
		this.symbol = fragment.symbol;
		this.name = fragment.name;
		this.logo = fragment.logos[0].url;
		this.logo_dark = fragment.logos[1].url;

		if (fragment.__typename === "EquityStockAsset") {
			this._isin = fragment.metrics?.isin;
			this._exchange = this.getExchangeName(fragment.exchangeId);
			this._isStock = true;
		} else if (fragment.__typename === "EquityEtfAsset") {
			this._isin = fragment.metrics?.isin;
			this._exchange = this.getExchangeName(fragment.exchangeId);
			this._isEtf = true;
		} else if (fragment.__typename === "EquityEtcAsset") {
			this._isin = fragment.metrics?.isin;
			this._exchange = this.getExchangeName(fragment.exchangeId);
			this._isEtc = true;
		}
	}

	// This is not great but we'll only have one exchange on launch,
	// and this help us avoiding having to add an extra GQL call
	private getExchangeName(exchangeId: string): string {
		switch (exchangeId) {
			case EXCHANGE_QUOTRIX_ID:
				return "Quotrix";
			default:
				return "";
		}
	}
}
